<script>
import Layout from "@/router/layouts/main";
import { api } from "@/state/services";

export default {
  locales: {
    pt: {
    },
    es: {
    }
  },
  components: {
    Layout,
  },
  data() {
    return {
      event: null,

      buy: {
        modal: false,
        loading: false,

        step: 1,
        qty: 1,
      },
    };
  },
  methods: {
    getEvent() {
      this.event = null;

      api
        .get('events/' + this.$route.params.id)
        .then((response) => {
          if (response.data.status == 'success') {
            this.event = response.data.event
          }
        })
    },
    showBuy() {
      this.buy.modal = false;
      this.buy.modal = true;
      this.buy.step = 1;
      this.buy.qty = 1;
    },
    buyEvent() {
      this.buy.loading = true;

      api
        .post("events", {
          id: this.event.id,
          qty: this.buy.qty,
        })
        .then((response) => {
          if (response.data.status == "success") {
            this.buy.modal = false;
            this.buy.loading = false;
            this.buy.step = 1;

            this.$router.push('/events/orders/' + response.data.order.id)
          } else {
            this.$toast.error(response.data.message)
          }

          this.buy.loading = false;
        })
        .catch(() => {
          this.buy.loading = false;
        });
    },
  },
  mounted() {
    this.getEvent()
  }
};
</script>

<template>
  <Layout>
    <ol class="breadcrumb">
      <li class="breadcrumb-item">
        <router-link tag="a" to="/">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" style="fill: rgba(0, 0, 0, 1);">
            <path d="M5 22h14a2 2 0 0 0 2-2v-9a1 1 0 0 0-.29-.71l-8-8a1 1 0 0 0-1.41 0l-8 8A1 1 0 0 0 3 11v9a2 2 0 0 0 2 2zm5-2v-5h4v5zm-5-8.59 7-7 7 7V20h-3v-5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v5H5z">
            </path>
          </svg>
        </router-link>
      </li>
      <li class="breadcrumb-item"><router-link tag="a" to="/events">Eventos</router-link></li>
      <li v-if="event && event.name" class="breadcrumb-item d-none d-sm-block">{{ event.name }}</li>
    </ol>

    <div v-if="event && event.name" class="page-title-box d-md-flex justify-content-between mb-3">
      <div>
        <h3>{{ event.name }}</h3>
        <p></p>
      </div>
    </div>

    <div v-if="!event" class="text-center">
      <b-spinner variant="default" role="status"></b-spinner>
    </div>
    <div v-else class="row justify-content-center">
      <div class="col-md-10 col-lg-6">
        <div class="card">
          <div class="card-body p-2">
            <iframe v-if="event.youtube" class="event-youtube rounded" :src="'https://www.youtube.com/embed/' + event.youtube + '?rel=0&modestbranding=1&autohide=1&showinfo=0&controls=1'"
              frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
            <img v-else-if="event.cover" class="event-cover" :src="event.cover" />
            <div class="p-2">
              <div class="d-flex align-items-center justify-content-between mb-4">
                <div>
                  <h5 class="mb-1">{{ event.name }}</h5>
                  <div class="d-flex align-items-center">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" style="fill: rgba(0, 0, 0, 1);">
                      <path d="M7 11h2v2H7zm0 4h2v2H7zm4-4h2v2h-2zm0 4h2v2h-2zm4-4h2v2h-2zm0 4h2v2h-2z"></path>
                      <path d="M5 22h14c1.103 0 2-.897 2-2V6c0-1.103-.897-2-2-2h-2V2h-2v2H9V2H7v2H5c-1.103 0-2 .897-2 2v14c0 1.103.897 2 2 2zM19 8l.001 12H5V8h14z"></path>
                    </svg>
                    <div class="ml-1 text-dark font-weight-bold">{{ event.date }}</div>
                  </div>
                </div>
                <div class="text-right">
                  <span class="bg-default rounded px-1 text-white" v-if="event.type == 'in_person'">PRESENCIAL</span>
                  <span class="bg-default rounded px-1 text-white" v-else>ONLINE</span>
                  <h5 class="mt-1 mb-0">{{ event.price | currency }}</h5>
                </div>
              </div>
              <div v-html="event.description"></div>
              <div class="d-block pt-3" v-if="event.url">
                <a target="_blank" :href="event.url" class="btn btn-outline-default text-uppercase">
                  <div class="d-flex align-items-center">
                    <span>Acessar</span>
                    <i class="bx bx-link font-size-18 ml-1"></i>
                  </div>
                </a>
              </div>
              <div v-if="event.sale && event.sale.status && event.sale.status == 'empty'" class="d-block mt-4">
                <button class="btn btn-default btn-lg btn-block text-uppercase" v-on:click="showBuy();">Comprar</button>
              </div>
              <div v-else-if="event.sale && event.sale.status && event.sale.status == 'pending'">
                <b-tabs justified nav-class="nav-tabs-custom mt-5" content-class="p-3 text-muted">
                  <b-tab v-for="(pay, method) in event.payments" :key="method">
                    <template v-slot:title>{{ pay.name }}</template>
                    <div v-if="method == 'pix'" class="py-3 text-center">
                      <div v-if="pay.pix && pay.pix.text">
                        <div v-if="pay.pix.image">
                          <div>
                            Use o código QR para prosseguir com a transação.
                          </div>
                          <div class="my-4 d-flex justify-content-center">
                            <div class="border rounded p-3">
                              <img style="width: 180px" :src="'data:image/png;base64,' + pay.pix.image" />
                            </div>
                          </div>
                          <div>
                            Ou utilize o Pix Copia e Cola para prosseguir com a transação.
                          </div>
                        </div>
                        <div v-else>
                          Use o Pix Copia e Cola para prosseguir com a transação.
                        </div>
                        <div class="my-4">
                          <fieldset class="text-break py-3">{{ pay.pix.text }}</fieldset>
                        </div>
                        <div>
                          <button class="btn btn-default btn-lg btn-block text-uppercase" v-clipboard:copy="pay.pix.text"
                            v-on:click="$toast.success('<strong>Copiado para a área de transferência.</strong><br>Agora, tudo o que você precisa fazer é acessar o aplicativo do seu banco e concluir o processo usando o <strong>Pix Copia e Cola</strong>.')">
                            Copiar Pix Copia e Cola
                          </button>
                        </div>
                      </div>
                    </div>
                    <div v-else-if="method == 'creditcard'">
                      <div class="row justify-content-center">
                        <b-form class="col-md-8" @submit.prevent="payCreditCard">
                          <div class="my-5">
                            <b-form-group label="Nome do Titular" label-for="holderName">
                              <b-form-input id="holderName" v-model="creditcard.holderName" type="text" required></b-form-input>
                            </b-form-group>
                            <b-form-group label="CPF do Titular" label-for="cpf">
                              <b-form-input id="cpf" v-model="creditcard.cpf" type="text" required v-mask="'###.###.###-##'"></b-form-input>
                            </b-form-group>
                            <b-form-group label="E-mail" label-for="email">
                              <b-form-input id="email" v-model="creditcard.email" type="email" required></b-form-input>
                            </b-form-group>
                            <b-form-group label="Celular" label-for="cellphone">
                              <b-form-input id="cellphone" v-model="creditcard.cellphone" type="text" required v-mask="'(##) #####-####'"></b-form-input>
                            </b-form-group>
                            <b-form-group label="CEP" label-for="address_zipcode">
                              <b-form-input v-on:blur="searchCep()" id="address_zipcode" v-model="creditcard.address_zipcode" type="text" required v-mask="'#####-###'"></b-form-input>
                            </b-form-group>
                            <b-form-group label="Endereço" label-for="address_street">
                              <b-form-input id="address_street" v-model="creditcard.address_street" type="text" required></b-form-input>
                            </b-form-group>
                            <b-form-group label="Número" label-for="address_number">
                              <b-form-input id="address_number" v-model="creditcard.address_number" type="text" required></b-form-input>
                            </b-form-group>
                            <b-form-group label="Complemento" label-for="address_complement">
                              <b-form-input id="address_complement" v-model="creditcard.address_complement" type="text"></b-form-input>
                            </b-form-group>
                            <b-form-group label="Bairro" label-for="address_district">
                              <b-form-input id="address_district" v-model="creditcard.address_district" type="text" required></b-form-input>
                            </b-form-group>
                            <b-form-group label="Cidade" label-for="address_city">
                              <b-form-input id="address_city" v-model="creditcard.address_city" type="text" required></b-form-input>
                            </b-form-group>
                            <b-form-group label="Estado" label-for="address_state">
                              <b-form-select id="address_state" v-model="creditcard.address_state" required placeholder="Selecione um estado">
                                <option value="" disabled></option>
                                <option value="AC">Acre</option>
                                <option value="AL">Alagoas</option>
                                <option value="AP">Amapá</option>
                                <option value="AM">Amazonas</option>
                                <option value="BA">Bahia</option>
                                <option value="CE">Ceará</option>
                                <option value="DF">Distrito Federal</option>
                                <option value="ES">Espírito Santo</option>
                                <option value="GO">Goiás</option>
                                <option value="MA">Maranhão</option>
                                <option value="MT">Mato Grosso</option>
                                <option value="MS">Mato Grosso do Sul</option>
                                <option value="MG">Minas Gerais</option>
                                <option value="PA">Pará</option>
                                <option value="PB">Paraíba</option>
                                <option value="PR">Paraná</option>
                                <option value="PE">Pernambuco</option>
                                <option value="PI">Piauí</option>
                                <option value="RJ">Rio de Janeiro</option>
                                <option value="RN">Rio Grande do Norte</option>
                                <option value="RS">Rio Grande do Sul</option>
                                <option value="RO">Rondônia</option>
                                <option value="RR">Roraima</option>
                                <option value="SC">Santa Catarina</option>
                                <option value="SP">São Paulo</option>
                                <option value="SE">Sergipe</option>
                                <option value="TO">Tocantins</option>
                              </b-form-select>
                            </b-form-group>
                            <hr class="my-5">
                            <b-form-group label="Número de Parcelas" label-for="creditcard.installment">
                              <b-form-select id="installment" v-model="creditcard.installment" :options="creditcard.installments" required></b-form-select>
                            </b-form-group>
                            <b-form-group label="Número do Cartão" label-for="number">
                              <b-form-input id="number" v-model="creditcard.number" type="text" required v-mask="'#### #### #### ####'"></b-form-input>
                            </b-form-group>
                            <div class="row">
                              <div class="col-12 col-md-6">
                                <b-form-group label="Vencimento" label-for="expiryDate">
                                  <b-input-group>
                                    <b-form-input id="expiryMonth" v-model="creditcard.expiryMonth" type="text" placeholder="Mês" maxlength="2" required v-mask="'##'"></b-form-input>
                                    <b-form-input id="expiryYear" v-model="creditcard.expiryYear" type="text" placeholder="Ano" maxlength="2" required v-mask="'##'"></b-form-input>
                                  </b-input-group>
                                </b-form-group>
                              </div>
                              <div class="col-12 col-md-6">
                                <b-form-group label="Código de Segurança" label-for="cvv">
                                  <b-form-input id="cvv" v-model="creditcard.cvv" type="text" required v-mask="'###'"></b-form-input>
                                </b-form-group>
                              </div>
                            </div>
                          </div>
                          <div class="d-flex justify-content-between align-items-center">
                            <button class="btn btn-default btn-lg mr-3" type="submit" :disabled="creditcard.loading">
                              Pagar
                              <b-spinner v-if="creditcard.loading" small class="ml-2 align-middle" variant="white" role="status"></b-spinner>
                            </button>
                          </div>
                        </b-form>
                      </div>
                    </div>
                  </b-tab>
                  <b-tab key="balance" :active="balance.pay >= 0">
                    <template v-slot:title>Saldo em Conta</template>
                    <div class="mt-4 text-center">
                      <template v-if="balance.pay >= 0">
                        <p>Deseja pagar esse pedido com o seu saldo?</p>
                        <p>Seu saldo atual é de <strong>{{ balance.total | currency }}</strong> e seu saldo após o pagamento será de <strong>{{ balance.total - event.price | currency }}</strong>.</p>
                        <button class="btn btn-default mr-3" v-on:click="payOrder()">
                          Confirmar
                          <b-spinner v-if="balance.loading" small class="ml-2 align-middle" variant="white" role="status"></b-spinner>
                        </button>
                      </template>
                      <template v-else>
                        <p>No momento você não possui saldo suficiente para realizar o pagamento do pedido.</p>
                      </template>
                    </div>
                  </b-tab>
                </b-tabs>
              </div>
              <div v-else-if="event.sale && event.sale.status && event.sale.status == 'approved'">
                <div class="py-4 text-center text-success d-flex align-items-center justify-content-center" style="gap: 5px">
                  <svg xmlns="http://www.w3.org/2000/svg" width="35" height="35" viewBox="0 0 24 24" style="fill: rgba(52, 195, 145, 1);">
                    <path d="m2.394 13.742 4.743 3.62 7.616-8.704-1.506-1.316-6.384 7.296-3.257-2.486zm19.359-5.084-1.506-1.316-6.369 7.279-.753-.602-1.25 1.562 2.247 1.798z"></path>
                  </svg>
                  <h5 class="m-0 font-size-15 text-success pt-1">
                    PAGAMENTO CONFIRMADO!
                  </h5>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <b-modal v-model="buy.modal" v-if="event" modal-class="modal-right" hide-header hide-footer>
      <div class="d-flex justify-content-between mb-5">
        <h4 class="m-0">Comprar Ingresso</h4>
        <a class="btn btn-outline-link p-0" v-on:click="buy.modal = false">Fechar</a>
      </div>
      <div class="">
        <h5>Confirma a compra do ingresso <strong>"{{ event.name }}"</strong>?</h5>
        <b-form-group id="qty-group" class="mt-4" :label="t('Quantidade')" label-for="qty">
          <b-form-input id="qty" class="text-center" v-model="buy.qty" type="number" min="1" max="100" inputmode="numeric" lg></b-form-input>
        </b-form-group>
        <div>Total</div>
        <h3>{{ event.price * buy.qty | currency }}</h3>
      </div>
      <div class="mt-4">
        <button class="btn btn-default btn-lg btn-block text-uppercase" v-on:click="buyEvent();">
          Confirmar
          <b-spinner v-if="buy.loading" small class="ml-2 align-middle" variant="white" role="status"></b-spinner>
        </button>
      </div>
    </b-modal>
  </Layout>
</template>

<style scoped>
.event-cover {
  border-radius: 5px;
  margin-bottom: 20px;
  width: 100%;
  object-fit: cover;
  aspect-ratio: 16 / 9;
}
.event-youtube {
  margin-bottom: 20px;
  width: 100%;
  aspect-ratio: 16 / 9;
}
</style>
